import { Message } from '@arco-design/web-vue';
import { poolClueService, clientService, leadsService, priceService, contractService, salesOrderService, customService, opportunityService, formulaFieldService } from '@/api/';
import { useI18n } from 'vue-i18n';
import { tools } from '@/utils/tools';
import { useContactsStore } from '@/store';
// import { orgId, lingChuOrgId, cxwhOrgIds } from '@/utils/const';
import { useOutCallStore } from '@/store';

export default function useButtonEvent() {
  const { t } = useI18n();
  const getContactList = useContactsStore();
  const { callConfig } = useOutCallStore();

  // 作废
  const invalidate = async (params) => {
    return new Promise((resolve, reject) => {
      async function invalidateObj() {
        const newParams = JSON.parse(JSON.stringify(params));
        if (params.entity != 12 && params.entity < 200) {
          delete newParams.entity;
        }
        let url;
        switch (params.entity) {
          case 1:
            url = leadsService.clueDelete(newParams);
            break;
          case 2:
            url = clientService.deleteCustomer(newParams);
            break;
          case 3:
            url = opportunityService.deleteOpportunity(newParams);
            break;
          case 6:
            url = priceService.delPriceSheet(newParams);
            break;
          case 8:
            url = contractService.delContract(newParams);
            break;
          case 10:
            url = salesOrderService.delOrder(newParams);
            break;
          case 13:
            url = salesOrderService.deleteSalesReturn(newParams);
            break;
          case 101:
            url = leadsService.clueDelete(newParams);
            break;
          default:
            url = customService.abandonCustomData(newParams);
        }
        try {
          const json = await url;
          if (!json.error) {
            if (json.result || json.result === null) {
              resolve(true);
              Message.success('操作成功');
            } else {
              resolve(false);
              Message.error(params.entity == 2 ? t('tips.costomerEsc') : params.entity == 3 ? t('tips.opportunityEsc') : '操作失败');
            }
          } else {
            resolve(false);
            Message.error(json.error?.msg || t('操作失败'));
          }
        } catch (e) {
          reject(false);
          Message.error(e.message || e.statusText || t('操作失败'));
        }
      }
      invalidateObj();
    });
  };
  // 分享
  const shareRowData = (params) => {
    return new Promise((resolve) => {
      async function share() {
        try {
          const res = await leadsService.clueShareCareMessage(params);
          if (!res.error) {
            Message.success(t('分享成功'));
            resolve(true);
          } else {
            resolve(false);
            Message.error(res.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      }
      share();
    });
  };
  // 领取线索池
  const collection = (params) => {
    return new Promise((resolve) => {
      async function check() {
        try {
          const res = await poolClueService.poolTake(params);
          if (!res.error) {
            Message.success(t('领取成功'));
            resolve(true);
          } else {
            resolve(false);
            Message.error(res.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      }
      check();
    });
  };
  // 线索退回
  const clueReturn = async (params) => {
    return new Promise((resolve) => {
      async function returnLeads() {
        try {
          const json = await leadsService.clueBackCheck({ businessIds: [params.id] });
          if (!json.error) {
            resolve(true);
          } else {
            resolve(false);
            Message.error(json.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      }
      returnLeads();
    });
  };
  // 删除
  const deleteObj = async (params) => {
    return new Promise((resolve) => {
      async function objDelete() {
        try {
          const json = await customService.deleteCustomData(params);
          if (!json.error) {
            resolve(true);
            Message.success(t('操作成功'));
          } else {
            resolve(false);
            Message.error(json.error?.msg || t('操作失败'));
          }
        } catch (e) {
          Message.error(e.message || e.statusText || t('操作失败'));
        }
      }
      objDelete();
    });
  };
  // 根据主键查询线索
  const getTaskId = async (params) => {
    return new Promise((resolve) => {
      async function getMsqTaskId() {
        try {
          const res = await leadsService.getMsqlTaskId(params);
          if (!res.error) {
            console.log(163, res);
            resolve(res.result);
          } else {
            Message.error(res.error?.msg || t('获取数据失败'));
          }
        } catch (e) {
          Message.error(e.message || e.statusText || t('获取数据失败'));
        }
      }
      getMsqTaskId();
    });
  };
  // 是否是线索池管理员（线索池分配）
  const isPoolManager = async (params) => {
    return new Promise((resolve) => {
      const checkManager = async () => {
        try {
          const res = await poolClueService.isManager(params);
          if (!res.error) {
            resolve(res.result);
          } else {
            Message.error(res.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      };
      checkManager();
    });
  };
  // 拨打电话
  const dialCallPhone = (res) => {
    return new Promise((resolve) => {
      async function callPhone() {
        // 如果orgid 是7 是领储 则展示天科云
        if (callConfig.default?.platformCode === 'kty') {
          resolve({ type: 2 });
          return;
        }
        // 如果orgid 是12 是条道 则传显科技
        if (callConfig.default?.platformCode === 'cx') {
          resolve({ type: 3 });
          return;
        }
        //拨打电话
        getContactList
          .callOut({
            id: res.businessId, //主键id
            type: res.type,
            callee: tools.clearCountryNum(res.mobile),
            calleeName: res.name,
            linkManId: res.id //联系人id
          })
          .then(() => {
            resolve({ type: 4 });
          });
      }
      callPhone();
    });
  };
  // 数据校准 && 批量数据校准
  const handleDataCalibration = async (entity, ids) => {
    return new Promise((resolve) => {
      async function check() {
        try {
          const res = await formulaFieldService.calculationCalibration({
            entityId: entity,
            businessIds: ids
          });
          if (!res.error) {
            resolve(true);
          } else {
            resolve(false);
            Message.error(res.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      }
      check();
    });
  };

  return {
    collection,
    isPoolManager,
    invalidate,
    shareRowData,
    clueReturn,
    deleteObj,
    getTaskId,
    dialCallPhone,
    handleDataCalibration
  };
}
